/**
 * Check if the app is running in Electron environment
 */
export function isElectron(): boolean {
  // Check if window.api exists (our custom preload API)
  if (typeof window !== "undefined" && window.api) {
    return true;
  }

  // Fallback checks
  if (typeof window !== "undefined") {
    // Check for Electron user agent
    if (window.navigator?.userAgent?.toLowerCase().includes("electron")) {
      return true;
    }
  }

  // Check for process.versions.electron
  if (
    typeof process !== "undefined" &&
    process.versions &&
    process.versions.electron
  ) {
    return true;
  }

  return false;
}

/**
 * Check if the app is running in development mode
 */
export function isDevelopment(): boolean {
  return process.env.NODE_ENV === "development";
}

/**
 * Check if the app is running in production mode
 */
export function isProduction(): boolean {
  return process.env.NODE_ENV === "production";
}
